module.exports = new __parcel__URL__("trello-right.e6e102c7.svg").toString();